import _ from "lodash";
import ACTIONS from "../veritas-report-gen/ReportGeneratorActions";

const initialState = {
    filename: "",
}

const csvReportGenReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.Reports.CSV_REPORT_SUCCESS: {
            let newState = _.cloneDeep(state);

            // create a new blob with the data from payload.
            let blob = new Blob([action.payload.report], {
                type: 'text/csv;charset=utf-8;'
            });
            // standard blob handling for saving files.
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, action.payload.filename);
            } else {
                let downloadLink = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                downloadLink.href = url;
                newState.filename = action.payload.filename;
                downloadLink.download = newState.filename;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(downloadLink);
            }

            return newState;
        }

        default:
            return state;
    }
}

export default csvReportGenReducer;
